import * as React from "react";
import {Component} from "react";

export default class SiteErrorBoundary extends Component<any, any> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
  }

  render() {
    if (this.state.hasError) {
      return <div className={"container"}><h4>Something is wrong with the site. Please try again later.</h4></div>;
    }

    return this.props.children;
  }
}